import { render, staticRenderFns } from "./GlazingType.vue?vue&type=template&id=45399d57&scoped=true"
import script from "./GlazingType.vue?vue&type=script&lang=ts"
export * from "./GlazingType.vue?vue&type=script&lang=ts"
import style0 from "./GlazingType.vue?vue&type=style&index=0&id=45399d57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45399d57",
  null
  
)

export default component.exports